import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';

const MentionsLegalesPage = () => {
  useEffect(() => {
    document.title = "Mentions Légales | Cocoonut Digital Strasbourg";
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Helmet>
        <title>Mentions Légales | Cocoonut Digital Strasbourg</title>
        <meta name="description" content="Mentions légales de Cocoonut Digital, studio de création de contenu et social media management basé à Strasbourg, France." />
        <link rel="canonical" href={`${window.location.origin}/mentions-legales`} />
      </Helmet>
      {/* Header */}
      <div className="bg-[#1a3a52] py-8">
        <div className="container mx-auto px-6 lg:px-8">
          <Link 
            to="/" 
            className="inline-flex items-center gap-2 text-white/80 hover:text-white transition-colors mb-4"
          >
            <ArrowLeft size={20} />
            <span>Retour à l'accueil</span>
          </Link>
          <h1 className="text-3xl md:text-4xl font-brand-display text-white">Mentions Légales</h1>
        </div>
      </div>

      {/* Content */}
      <div className="container mx-auto px-6 lg:px-8 py-16">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="max-w-3xl mx-auto"
        >
          {/* Éditeur du site */}
          <section className="mb-10">
            <h2 className="text-xl font-semibold text-[#1a3a52] mb-4">Éditeur du site</h2>
            <div className="text-[#151515]/80 space-y-1">
              <p><strong>GEOFFROY RHAMELLENE</strong></p>
              <p>Nom commercial : Cocoonut Concept Creations</p>
              <p>Entreprise individuelle – Micro-entreprise</p>
              <p>SIREN : 989 162 847</p>
              <p>SIRET : 989 162 847 00010</p>
              <p>Adresse : 8 rue du Commandant L'Herminier, 67640 Fegersheim, France</p>
              <p>Email : <a href="mailto:rhamgffry@cocoonutconcept.com" className="text-[#d4a574] hover:underline">rhamgffry@cocoonutconcept.com</a></p>
            </div>
          </section>

          {/* Directeur de la publication */}
          <section className="mb-10">
            <h2 className="text-xl font-semibold text-[#1a3a52] mb-4">Directeur de la publication</h2>
            <p className="text-[#151515]/80">GEOFFROY RHAMELLENE</p>
          </section>

          {/* Hébergement */}
          <section className="mb-10">
            <h2 className="text-xl font-semibold text-[#1a3a52] mb-4">Hébergement</h2>
            <div className="text-[#151515]/80 space-y-1">
              <p><strong>Emergent Labs, Inc.</strong></p>
              <p>2261 Market Street #4010</p>
              <p>San Francisco, CA 94114</p>
              <p>États-Unis</p>
              <p>Site web : <a href="https://emergent.sh" target="_blank" rel="noopener noreferrer" className="text-[#d4a574] hover:underline">emergent.sh</a></p>
            </div>
          </section>

          {/* TVA */}
          <section className="mb-10">
            <h2 className="text-xl font-semibold text-[#1a3a52] mb-4">TVA</h2>
            <p className="text-[#151515]/80">
              TVA non applicable – article 293 B du CGI.
            </p>
          </section>

          {/* Propriété intellectuelle */}
          <section className="mb-10">
            <h2 className="text-xl font-semibold text-[#1a3a52] mb-4">Propriété intellectuelle</h2>
            <p className="text-[#151515]/80">
              L'ensemble du contenu de ce site (textes, images, vidéos, logos, etc.) est protégé par le droit d'auteur. Toute reproduction, représentation ou diffusion, totale ou partielle, sans autorisation préalable est interdite.
            </p>
          </section>

          {/* Crédits */}
          <section className="mb-10">
            <h2 className="text-xl font-semibold text-[#1a3a52] mb-4">Crédits</h2>
            <p className="text-[#151515]/80">
              Conception et réalisation : Cocoonut Concept Creations
            </p>
          </section>

        </motion.div>
      </div>
    </div>
  );
};

export default MentionsLegalesPage;
